import { Component, Input, OnInit, Output, EventEmitter, Optional } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { TextAreaInput, Warning } from '../../../../../utils/models/input.interface';
import { returnColorWarning, returnTextWarning, returnWarningIcon } from '../../../functions/utilities.service';
@Component({
  selector: 'textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TextareaInputComponent,
    },
  ],
})
export class TextareaInputComponent implements OnInit, ControlValueAccessor {
  warningIconTextareaInput = returnWarningIcon;
  colorWarningTextareaInput = returnColorWarning;
  textWarningTextareaInput = returnTextWarning;

  @Input() textAreaInput: TextAreaInput;

  @Input() warning: Warning;
  
  styleWarning = 
  `
    z-index: 2; 
    width: 16px; 
    height: 16px; 
    margin-right:10px; 
    align-self: flex-start; 
    position: relative; 
    top: 10px;
  `

  @Input() formControlName: string;

  @Output() valueEmitter: EventEmitter<string> = new EventEmitter<string>();

  constructor(@Optional() private controlContainer: ControlContainer) { }

  writeValue(value: any): void {
    this.textAreaInput.value = value;
  }

  onChange = (value: any) => {
    return value;
  };

  onTouched = (value: unknown) => {
    return value;
  };

  registerOnChange(onChange: (value: any) => any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  ngOnInit(): void {
    if(this.controlContainer) {
      const control = this.controlContainer.control.get(this.formControlName);
      if (control && control.hasValidator(Validators.required)) {
        this.textAreaInput.required.active = true;
      }
    }
  }

  setNewValue() {
    this.onChange(this.textAreaInput.value);
    this.valueEmitter.emit(this.textAreaInput.value);
  }
}
